export default __webpack_public_path__ + "static/media/Rectangle-2@2x.0aea814f.png";